<template>
  <div class="message-actions-container">
    <div
    v-show="controller.showActions"
    v-click-outside="onClickOutside"  
    class="actions-container"
    :style="getStyleLeft()"
    >
    <button
        :disabled="!controller.enableReagir"
        class="btn-action-list"
        :title="$t('sectionButtonEmoji.clickToChooseEmoji')"
        @click="onReactClick"
      >
      <i class="far fa-smile"></i>
        {{ $t("btReagir") }}
    </button>
    <button
        :disabled="!controller.enableResponder"
        class="btn-action-list"
        :title="$t('btResponder')"
        @click="onReplyClick"
      >
      <i class="fas fa-reply"></i>
        {{ $t("btResponder") }}
    </button>
      <button
        class="btn-action-list"
        :disabled="!controller.showActions || !controller.enableEncaminhar"
        :title="$t('infoMessages.shareMessageSeveralContacts')"
        @click="onShareClick"
      >
        <i class="fas fa-share-square"></i>
        {{ $t("btEncaminhar") }}
      </button>

      <button
        :disabled="!controller.enableDelete"
        class="btn-action-list btn-action-list--danger mt-1"
        @click="onDeleteClick"
      >
        <i class="fas fa-trash"></i>
        {{ $t("btApagar") }}
      </button>
    </div>
    <div
      v-show="controller.showMainMenuButton"
      class="message-action"
      :title="$t('infoMessages.showOptions')"
    >
      <button class="btn-action" @click="onMainButtonClick">
        <i class="fas fa-angle-up"></i>
      </button>
    </div>

    <!-- modal alerta contatos -->
    <b-modal 
      id="ModalAvisoSpam" 
      v-model="modalAlerta"
      :title="$t('infoMessages.avisoSpam')" 
      content-class="modal__lg"
      @hide="cancelEncaminhar">
      <h5>
        {{ $t("infoMessages.avisoNumeroBloqueado") }}
      </h5>
      <br>
      <br>
      <h5>
        {{ $t("infoMessages.avisoLeiaMais") }}
        <a href="https://www.whatsapp.com/legal/">https://www.whatsapp.com/legal/</a>
      </h5>
      <br>
      <br>
      <h5>
        {{ $t("infoMessages.perguntaConfirmacao") }}
      </h5>
      <h2>
        <span class="badge badge-warning">{{ this.modalContato.selected.length }} {{ $t("infoMessages.textContatos") }}   </span>
      </h2>
        <template v-slot:modal-footer="{ hide }">
          <h5>
            {{ $t("infoMessages.avisoConfirmacao") }}
          </h5>
          <b-button variant="danger" @click="hide">{{ $t("textNo") }}</b-button>
          <b-button variant="success" @click="onShareSend">{{ $t("textYes") }}</b-button>
        </template>
    </b-modal>

    <b-modal
      v-model="modalContato.show"
      id="ModalEncaminhar"
      content-class="modal__lg"
      no-close-on-backdrop
      :title="$t('infoMessages.shareMessage')"
      ok-variant="success"
      @ok="confirmEncaminhar"
      
    >
      <div class="row">
        <div class="col-sm-12">
          <h5>
            <span class="badge badge-warning"> {{ $t("textAtencao") }} </span>
            {{ $t("textEncaminhamentoSpam") }}
          </h5>
        </div>
      </div>

      <!-- <button @click="allIdsContatos">Teste teste</button> -->

      <FilterContactSpam
        class="filter__spacing"
        :dadosFiltradosCompanyPhone="chatTalksfilter"
        @filter-button="filtered"
      />

      <div class="container_contatos_filter">
        <div class="flex padding-2 space">
          <label for="">
            {{
              `${modalContato.selected.length} ${$t(
                "textContatosSelecionados"
              )}`
            }}
          </label>
          <span
            v-show="modalContato.selected.length >= 5"
            class="badge badge-danger"
          >
          </span>
        </div>
        <div class="flex padding-2 space">

          <b-form-checkbox
          v-model="iniciarAtendimento"
          name="check-button"
          >
          {{ $t("infoMessages.iniciarAtendimento") }}
          </b-form-checkbox>
        </div>
        
        <div class="padding-2">
          
          <span class="font-bold"> {{ $t("infoMessages.selecionarTodos") }} </span>
          <b-button :variant="stylesSelectAll()" @click="onSelectAll()">
            <i class="fa fa-check" style="color: black"></i>
          </b-button>
        </div>
      </div>

      <div v-if="loading" class="loader">
        <RotateSquare
          class="loading-position animated fadeIn"
          size="60px"
        ></RotateSquare>
      </div>

      <b-table
        :hover="true"
        responsive
        :items="chatTalksfilter.itens"
        :fields="fields"
        striped
        :per-page="chatTalksfilter.itensPorPagina"
      >
        <template v-slot:cell(urlPerfil)="{item, value}">
          
          <ProfilePicture 
            v-if="item.urlPerfil != 'x' "  
              :profilePicturePath="item.urlPerfil" :tipoConversa="item.enumTipoContato"/> 
                
          <ProfilePicture v-else-if="item.urlPerfil == 'x'" :customerName="item.nome"  :tipoConversa="item.enumTipoContato"/> 
        </template>

        <template v-slot:cell(acao)="data">
          <b-button
            :variant="getColorSelected(data)"
            :title="$t('textSelecionar')"
            @click="onRowSelected(data)"
          >
            <i class="fa fa-check" style="color: black"></i>
          </b-button>
        </template>
      </b-table>
      <b-pagination
        v-model="pagina"
        :total-rows="chatTalksfilter.total"
        :per-page="chatTalksfilter.itensPorPagina"
        align="right"
        size="md"
        class="mt-2"
      ></b-pagination>

      <template v-slot:modal-footer="{ hide }">
          <b-button variant="secondary" @click="hide">Cancelar</b-button>
          <b-button variant="success" @click="confirmEncaminhar">OK</b-button>
        </template>
    </b-modal>
  </div>
</template>

<script>
import FilterContactSpam from "../../components/chat/FilterContactSpam.vue"
import OrigemMensagem from "../../enums/OrigemMensagem"
import ProfilePicture from "../../components/chat/ProfilePicture"
import {mapGetters} from "vuex"
import RotateSquare from "@/components/RotateSquare.vue"

export default {
  name: "MessageAction",
  components: {FilterContactSpam, ProfilePicture, RotateSquare},
  props: {
    message: {
      type: Object,
      default: Object
    },
    controller: {
      type: Object,
      default: () => {
        return {
          showMainMenuButton: false,
          showActions: false,
          enableDelete: false,
          enableEncaminhar:true,
          enableReagir: true,
          enableResponder: true,
        }
      }
    },
    hiddenActions: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      telefoneIdSelected: "",
      iniciarAtendimento: false,
      loading: false,
      stateButtonOnSelectAll: false,
      chatTalksfilter: {
        contaId: this.$store.getters.getAutenticacao.contaSelecionadaId,
        numero: "",
        pessoa: "",
        pagina: 1,
        atendentes: null,
        etapas: null,
        status: 0,
        itens: [],
        telefone: {},
        isNova: false,
        isSemAtendente: false,
        ordem: 1,
        tipo:0,
        periodoConversaInicial: "",
        periodoConversaFinal: "",
        total: 0,
        itensPorPagina: 0
      },
      isFiltered: false,
      todosIdsContatos: [],
      pagina: 1,
      modalAlerta:false,
      modalContato: {
        searchTerm: "",
        total: 0,
        itensPorPagina: 0,
        selected: [],
        selectedAll: [],
        show: false,
        itens: [],
        pagina: 1,
        telefone: {},
        contaId: this.$store.getters.getAutenticacao.contaSelecionadaId
      }
    }
  },
  computed: {
    ...mapGetters("telefoneSelecionado/", {
      Filtro: "GET_FILTER"
    }),
    fields() {
      return [
        {
          key: "urlPerfil",
          label: "Contato",
          sortable: false
        },
        {
          key: "nome",
          label: this.$t("sectionAcesso.acessoLabelNome"),
          sortable: true
        },
        {key: "numero", label: this.$t("sectionConversas.conversasTelefone"), sortable: true},
        {
          key: "acao",
          label: this.$t("textSelecionado"),
          sortable: false,
          thClass: "center, wd-120-px"
        }
      ]
    }
  },
  watch: {
    pagina: function (val) {
      if (!this.isFiltered) this.getContacts(val, this.chatTalksfilter)
      else this.getChatTalksByFilter(val, this.chatTalksfilter)
    }
  },
  methods: {
    confirmEncaminhar() {
      // Lógica para confirmar
      if(this.modalContato.selected.length > 10){
        this.modalAlerta=true
      }else{
        this.onShareSend();
      }
      
    },
    cancelEncaminhar() {
      this.modalAlerta=false
    },
    getStyleLeft() {
      switch (this.message.origem) {
        case OrigemMensagem.Recebida:
          return "left: 0rem"
        case OrigemMensagem.Enviada:
          return "left: -8rem"
      }
    },
    onShareSend() {
      let vm = {}
      vm.Contatos = this.modalContato.selected
      vm.ContaId = this.$store.getters.getAutenticacao.contaSelecionadaId
      vm.Id = this.message.id
      vm.TelefoneId = this.message.telefoneId
      vm.IniciarAtendimento = this.iniciarAtendimento
      this.$http({
        url: "/mensagem-front/encaminhar/",
        data: vm,
        method: "POST"
      })
        .then(() => {
          this.modalContato.show = false
          this.modalAlerta = false
          this.onClickOutside()
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          })
        })
    },
    stylesSelectAll() {
      if (this.stateButtonOnSelectAll) return "success"
      else return "secondary"
    },
    getColorSelected(contatoId) {
      let contatoIdUser =
        contatoId.item.id == null || undefined
          ? contatoId.item.contatoId
          : contatoId.item.id

      if (
        this.modalContato.selected.filter((x) => x === contatoIdUser).length > 0
      )
        return "success"
      else return "secondary"
    },
    onRowSelected(contatoId) {
      let contatoIdUser =
        contatoId.item.id == null || undefined
          ? contatoId.item.contatoId
          : contatoId.item.id

      if (
        this.modalContato.selected.filter((x) => x === contatoIdUser).length > 0
      ) {
        let index = this.modalContato.selected.indexOf(contatoIdUser)
        this.modalContato.selected.splice(index, 1)
      } else this.modalContato.selected.push(contatoIdUser)
    },
    onSelectAll() {
      this.stateButtonOnSelectAll = !this.stateButtonOnSelectAll
      this.modalContato.selected = this.todosIdsContatos
      if (!this.stateButtonOnSelectAll) this.modalContato.selected = []
    },
    onMainButtonClick() {
      this.controller.showActions = !this.controller.showActions
      this.$emit("statusMessageAction", this.controller.showActions)
    },
    onDeleteClick() {
      this.controller.showActions = false
      this.onDeleteMessage()
    },
    async onShareClick() {
      this.loading = true

      this.modalContato.show = true
      this.modalContato.selected = []

      //this.chatTalksfilter.contaId = this.$store.getters.getAutenticacao.contaSelecionadaId
      //this.chatTalksfilter.telefone = this.Filtro

      await this.getChatTalksByFilter(1, this.chatTalksfilter)

      //this.getContacts(1, this.modalContato)
    },
     onReactClick(){
      this.controller.showActions = false
      this.$emit("reactMessageAction")
    },
     onReplyClick(){
      this.controller.showActions = false
      this.$emit("replyMessageAction")
    },
    async filtered(page, value) {
      console.log("filtro gerado encaminha", value)
      this.isFiltered = true
      await this.getChatTalksByFilter(1, value)
    },
    onClickOutside() {
      this.controller.showActions = false
      this.$emit("statusMessageAction", this.controller.showActions)
    },
    getContacts(page, filterDefault) {
      this.chatTalksfilter.telefone = this.Filtro

      let filter = {
        ContaId: this.chatTalksfilter.contaId,
        PorPagina: 5,
        Nome: "",
        Telefone: "",
        Pagina: page
      }

      this.$http({
        url: "/contato/obter-grid",
        data: filter,
        method: "POST"
      })
        .then((response) => {
          this.chatTalksfilter.itens = response.data.itens
          this.chatTalksfilter.total = response.data.total
          this.chatTalksfilter.pagina = response.data.pagina
          this.chatTalksfilter.itensPorPagina = response.data.itensPorPagina

          setTimeout(() => {
            //this.allIdsContatos()
          }, 2000)
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          })
        })
    },

     getChatTalksByFilter(page = 1, searchTerm) {
      this.chatTalksfilter.contaId =
      this.$store.getters.getAutenticacao.contaSelecionadaId
      this.chatTalksfilter.telefone = this.Filtro
      this.chatTalksfilter.pagina = page

     // console.log(searchTerm == 0)

      this.$http({
        url: "contato/obter-grid-filter",
        data: searchTerm,
        method: "POST"
      })
        .then( (response) => {
          this.loading = true
         // console.log("ccc", response)
          // if(response.data.itens != )
           this.todosIdsContatos = [...response.data.itens].map((x) => x.contatoId)
          
          this.chatTalksfilter.itens = response.data.itens
          this.chatTalksfilter.total = response.data.total
          this.chatTalksfilter.itensPorPagina = 5
          this.chatTalksfilter.pagina = response.data.pagina
          
          this.loading = false
          //console.log(this.todosIdsContatos)
          setTimeout(() => {
            //this.allIdsContatos()
          },1000)
        })
        .catch((err) => {
          console.warn("Erro ao retornar Conversas do chat: ", err)
          this.$notify({
            data: err.response.data.erros,
            type: "warn",
            duration: 10000
          })

          this.updatedHoursChatTalks = `${this.$t(
            "sectionKanban.notUpdatedAt"
          )}`
        })
    },
    onDeleteMessage() {
      this.$http({
        url:
          "mensagem-front/remover/" +
          this.message.id +
          "/" +
          this.$store.getters.getAutenticacao.contaSelecionadaId,
        method: "DELETE"
      })
        .then(() => {
          const successMessageDeleted = this.$t(
            "infoMessages.successMessageDeleted"
          )
          this.$notify({
            data: [successMessageDeleted],
            type: "success",
            duration: 3000
          })
        })
        .catch((err) => {
          this.$notify({
            data: err.response.data.erros,
            type: "warn",
            duration: 10000
          })
        })
    }
  }
}
</script>

<style lang="scss">
.container_contatos_filter {
  align-items: center;

  display: flex;
    justify-content: space-around;
    padding-right: 5rem;
  // justify-content: space-evenly;
}
.modal__lg {
  width: 50rem !important;
}
.filter__spacing {
  padding: 0.4rem;
}
.select__all {
  margin-left: 12.75rem;
}
.padding-2 {
  padding: 0.4rem;
}
.font-bold {
  font-weight: bold;
  font-size: 0.875rem;
}
.loader {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
